import { defineComponent as _defineComponent } from 'vue'
import { reactive, watch } from "vue";
import VModal from "@/components/vModal.vue";
import { BookDemoRequestDto } from "@/models/Restaurants/BookDemoRequestDto";

type vBookDemoRequestModalProps = {
  showModal: boolean;
  initialName?: string;
  initialCompanyName?: string;
  initialEmail?: string;
  initialPhone?: string;
  isSubmitting?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vBookDemoRequestModal',
  props: {
    showModal: { type: Boolean, default: false },
    initialName: { default: "" },
    initialCompanyName: { default: "" },
    initialEmail: { default: "" },
    initialPhone: { default: "" },
    isSubmitting: { type: Boolean, default: false }
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, initialName: string, initialCompanyName: string, initialEmail: string, initialPhone: string, isSubmitting: boolean };





const form = reactive<BookDemoRequestDto>({
  name: "",
  email: "",
  phone: "",
  question: "",
});

const errors = reactive({
  name: "",
  email: "",
  phone: "",
});

const resetErrors = () => {
  errors.name = "";
  errors.email = "";
  errors.phone = "";
};

const resetForm = () => {
  form.name = props.initialName || "";
  form.email = props.initialEmail || "";
  form.phone = props.initialPhone || "";
  form.question = "";
  resetErrors();
};

watch(
  () => props.showModal,
  (showModal) => {
    if (showModal) {
      resetForm();
    }
  }
);

const validateForm = () => {
  resetErrors();
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let isValid = true;

  if (!form.name || !form.name.trim()) {
    errors.name = "Name is required.";
    isValid = false;
  }

  if (!form.email || !form.email.trim()) {
    errors.email = "Email is required.";
    isValid = false;
  }
  else if (!emailPattern.test(form.email.trim())) {
    errors.email = "Please enter a valid email address.";
    isValid = false;
  }

  if (!form.phone || !form.phone.trim()) {
    errors.phone = "Phone is required.";
    isValid = false;
  }

  return isValid;
};

const onSubmit = () => {
  if (props.isSubmitting) {
    return;
  }

  if (!validateForm()) {
    return;
  }

  emit("submit", {
    name: form.name.trim(),
    companyName: props.initialCompanyName || "",
    email: form.email.trim(),
    phone: form.phone.trim(),
    question: form.question?.trim() || undefined,
  });
};

return { __sfc: true,props, emit, form, errors, resetErrors, resetForm, validateForm, onSubmit, VModal }
}

})